import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';

interface GuestGuardProps {}

const GuestGuard: FC<PropsWithChildren<GuestGuardProps>> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to='/orders' />;
  }

  return <>{children}</>;
};

export default GuestGuard;
